// extracted by mini-css-extract-plugin
export default {"itemContainer":"NavigationItem_itemContainer__lN9aQ","itemText":"NavigationItem_itemText__uCzPp"};